// extracted by mini-css-extract-plugin
module.exports = {"addCategoryScreen":"AddVendorScreen_addCategoryScreen__F2kae","addCategoryHeading":"AddVendorScreen_addCategoryHeading__2-ibg"};